var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9883 6.98804H9.98828C8.99372 6.98804 8.03989 7.38313 7.33663 8.08639C6.63337 8.78965 6.23828 9.74348 6.23828 10.738V21.763C6.23828 39.0805 20.882 44.8255 23.8183 45.7968C24.5774 46.0517 25.3991 46.0517 26.1583 45.7968C29.0945 44.8218 43.7383 39.0805 43.7383 21.763V10.738C43.7383 9.74348 43.3432 8.78965 42.6399 8.08639C41.9367 7.38313 40.9828 6.98804 39.9883 6.98804ZM39.2383 21.763C39.2383 35.5555 27.8889 40.4249 24.9883 41.4505C22.0877 40.4343 10.7383 35.5649 10.7383 21.7724V11.488H39.2383V21.763ZM15.8964 27.3299C15.6871 27.1206 15.5211 26.8721 15.4078 26.5987C15.2946 26.3252 15.2363 26.0322 15.2363 25.7362C15.2363 25.4402 15.2946 25.1471 15.4078 24.8736C15.5211 24.6002 15.6871 24.3517 15.8964 24.1424C16.1057 23.9331 16.3542 23.7671 16.6276 23.6538C16.9011 23.5406 17.1942 23.4823 17.4902 23.4823C17.7861 23.4823 18.0792 23.5406 18.3527 23.6538C18.6261 23.7671 18.8746 23.9331 19.0839 24.1424L21.9883 27.0505L30.8964 18.1424C31.3191 17.7197 31.8924 17.4823 32.4902 17.4823C33.0879 17.4823 33.6612 17.7197 34.0839 18.1424C34.5066 18.5651 34.7441 19.1384 34.7441 19.7362C34.7441 20.3339 34.5066 20.9072 34.0839 21.3299L23.5839 31.8299C23.3749 32.0397 23.1265 32.2061 22.853 32.3197C22.5795 32.4332 22.2863 32.4917 21.9902 32.4917C21.694 32.4917 21.4008 32.4332 21.1273 32.3197C20.8538 32.2061 20.6054 32.0397 20.3964 31.8299L15.8964 27.3299Z",
    fill: "url(#paint0_linear_1564_24037)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1564_24037",
    x1: 24.9883,
    y1: 6.98804,
    x2: 24.9883,
    y2: 45.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/ShieldCheck.71b5d2dcf0873aa7c8ed7bd2fbd88171.svg";
export { ForwardRef as ReactComponent };